(() => {
  const initTabs = (root) => {
    root.querySelectorAll('[data-mii-tabs]').forEach((tabGroup) => {
      if (tabGroup.dataset.miiTabsInitialized === 'true') return;

      tabGroup.dataset.miiTabsInitialized = 'true';
      const tabs = Array.from(tabGroup.querySelectorAll('[data-mii-tab]'));
      const panels = Array.from(tabGroup.querySelectorAll('[data-mii-panel]'));

      const activateTab = (nextTab, moveFocus = false) => {
        tabs.forEach((tab) => {
          const isActive = tab === nextTab;
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });

        panels.forEach((panel) => {
          panel.hidden = panel.id !== nextTab.getAttribute('aria-controls');
        });

        if (moveFocus) nextTab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

          event.preventDefault();
          let nextIndex = index;

          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;

          activateTab(tabs[nextIndex], true);
        });
      });
    });
  };

  const initMiiHome = (root) => {
    if (!root || root.dataset.miiInitialized === 'true') return;

    root.dataset.miiInitialized = 'true';
    root.classList.add('mii-enhanced');
    initTabs(root);

    const revealItems = root.querySelectorAll('.mii-reveal');

    if (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      !('IntersectionObserver' in window)
    ) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          currentObserver.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.08,
      }
    );

    revealItems.forEach((item) => observer.observe(item));
  };

  const initAll = () => {
    document.querySelectorAll('[data-mii-home]').forEach(initMiiHome);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initMiiHome(event.target.querySelector('[data-mii-home]'));
  });
})();
